import React from 'react'
import { useSelector } from 'react-redux'
import { CochezTemplates } from './components/cochez/CochezTemplates'
import { NoveyTemplates } from './components/novey/NoveyTemplates'
import { companiesId } from 'Utils/constants'

export const REGULAR_CMF = 'REGULAR_CMF'
export const OFFER_CMF = 'OFFER_CMF'
export const REGULAR = 'REGULAR'
export const OFFER = 'OFFER'
export const SPECIAL_CMF = 'SPECIAL_CMF'

export const Template = ({ products, i }) => {
  const { CompanyId } = useSelector(state => state.company)
  const isNovey = CompanyId?.toUpperCase() === companiesId.novey

  if (isNovey) return <NoveyTemplates products={products} i={i} />

  return <CochezTemplates products={products} i={i} />
}
